import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import KeyPyramidChart from "./keypyramid";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { greendown, greenstraight, infogrey, infored, lowrisk, mediumrisk, raisered, redhazard } from "../utils/safetysvgs/safetysvg";

const KeyInsights = () => {
  const options = ["Pyramid", "Table"];
  const [selectedOption, setSelectedOption] = useState("Pyramid");

  const pyramidData = [
    { label: "Fatal", value: 0, status: "Severe" },
    { label: "Lost-Time", value: 0, status: "Severe" },
    { label: "Recordable", value: 0, status: "Moderate" },
    { label: "FAP", value: 3, status: "Moderate" },
    { label: "PSI", value: 2, status: "Moderate" },
    { label: "First Aids", value: 10, status: "Minor" },
    { label: "Near Misses", value: 6, status: "Minor" },
    { label: "At-Risk", value: 312, status: "Minor" },
  ];

  return (
    <div className="w-full flex flex-col gap-2 md:flex-row md:gap-2">
      {/* Card 1 */}
      <div className="flex-1 rounded-[12.75px] border border-2 border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm">
        {/* Header Row */}
        <div className="flex justify-between items-center flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <h2 className="text-base font-semibold text-start text-[#0A0A0A]">Injury Pyramid</h2>
           {infogrey}
          </div>
          <div className="flex rounded-[12.75px] bg-[#DBEAFE] p-1">
            {options.map((label) => {
              const isSelected = selectedOption === label;
              return (
                <button
                  key={label}
                  onClick={() => setSelectedOption(label)}
                  className={`px-3 py-1 text-sm font-medium rounded-[12.75px] transition-colors duration-200 ${
                    isSelected ? "bg-white text-[#0A0A0A]" : "bg-transparent text-[#0A0A0A]"
                  }`}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>

        <KeyPyramidChart data={pyramidData} />
        {/* You can add the table rendering here for "Table" selection */}
      </div>

      {/* Card 2 */}
      <div className="flex-1 rounded-[12.75px] border border-2 border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm">
    <div className="flex items-center gap-2">
            <h2 className="text-base font-semibold text-start text-[#0A0A0A]">Safety Risk Areas</h2>
          {infogrey}
          </div>
<div className="mt-4">
  {/* Header row */}
  <div className="text-[#C10007] text-start flex gap-1 items-center">
   {infored}
    High Risk Areas - Immediate Action Required
  </div>

  {/* Next row box */}
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
    className="absolute top-2 right-2 px-2 py-0.5  text-[#E7000B]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-grey-94, #E0E7FF)',
    }}
  >
    95%
  </div>

  {/* First row: Title */}
  <div className="text-[#C10007] font-semibold text-[17px]">
    Hazard Recognition
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    Identifying workplace hazards
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
      Schedule hazard recognition training for all personnel
    </span>
  </div>
</div>
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
    className="absolute top-2 right-2 px-2 py-0.5  text-[#E7000B]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-grey-94, #E0E7FF)',
    }}
  >
    85%
  </div>

  {/* First row: Title */}
  <div className="text-[#C10007] font-semibold text-[17px]">
Tool Usage
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
  Proper tool selection and operation
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
Implement enhanced tool inspection program
    </span>
  </div>
</div>
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
    className="absolute top-2 right-2 px-2 py-0.5  text-[#E7000B]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-grey-94, #E0E7FF)',
    }}
  >
    80%
  </div>

  {/* First row: Title */}
  <div className="text-[#C10007] font-semibold text-[17px]">
PPE Compliance
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
Proper use of required PPE
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
Review and update PPE requirements for specific
tasks
    </span>
  </div>
</div>
</div>
<div className="mt-4">
  {/* Header row */}
  <div className="text-[#BB4D00] text-start flex gap-1 items-center">
    {mediumrisk}
  Medium Risk Areas - Attention Needed
  </div>

  {/* Next row box */}
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
    className="absolute top-2 right-2 px-2 py-0.5  text-[#E17100]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-yellow-89, #FEF3C6)',
    }}
  >
    75%
  </div>

  {/* First row: Title */}
  <div className="text-[#BB4D00] font-semibold text-[17px]">
Work Environment
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
Site conditions and housekeeping
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
   Conduct daily housekeeping inspections
    </span>
  </div>
</div>
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
  className="absolute top-2 right-2 px-2 py-0.5  text-[#E17100]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-yellow-89, #FEF3C6)',
    }}
  
  >
    85%
  </div>

  {/* First row: Title */}
 <div className="text-[#BB4D00] font-semibold text-[17px]">
Body Mechanics
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
Proper body positioning during tasks
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
Provide ergonomics training for manual tasks
    </span>
  </div>
</div>
  <div className="relative mt-2 p-3 rounded-[6.75px] text-start"
  style={{
    border: '1px solid #FFC9C9',
    backgroundColor: '#FEF2F2',
  }}
>
  {/* Top-right badge */}
  <div
  className="absolute top-2 right-2 px-2 py-0.5  text-[#E17100]"
    style={{
      borderRadius: '16777200px',
      background: 'var(--color-yellow-89, #FEF3C6)',
    }}
  >
    80%
  </div>

 <div className="text-[#BB4D00] font-semibold text-[17px]">
Communication
  </div>

  {/* Second row: Subheading */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
Clear safety communication
  </div>

  {/* Third row: Action with semibold prefix */}
  <div className="text-[#0A0A0A] text-[14px] mt-1">
    <span className="font-semibold">Action: </span>
    <span className="font-normal">
Implement pre-task safety briefings
    </span>
  </div>
</div>
</div>
<div className="mt-4">
  {/* Header row */}
  <div className="text-[#008236] text-start flex gap-1 items-center">
{lowrisk}
    Low Risk Areas - Monitor
  </div>

  {/* Styled box with content */}
  <div className="flex gap-2 mt-4 ">
    {/* Card 1 */}
    <div className="flex items-center justify-between w-full p-3 bg-[#FEF2F2] border-2 border-[#B9F8CF] rounded-[6.75px] text-start ">
      <div>Procedure</div>
      <div
        className=" px-2 py-0.5  text-[#00A63E]"
        style={{
          borderRadius: '16777200px',
          background: '#DBEAFE',
        }}
      >
        55%
      </div>
    </div>

    {/* Card 2 */}
    <div className="flex items-center justify-between w-full p-3 bg-[#FEF2F2] border-2 border-[#B9F8CF] rounded-[6.75px] text-start space-y-2">
      <div>Energy Isolation</div>
      <div
        className=" px-2 py-0.5 text-[#00A63E]"
        style={{
          borderRadius: '16777200px',
          background: '#DBEAFE',
        }}
      >
        55%
      </div>
    </div>
    
  </div>
  <div className="mt-4">
    <div className="rounded-[6.75px] border border-2 cursor-pointer font-semibold border-gray-300 bg-white p-3 text-sm text-[#1D2951]">
  View Full Risk Assessment Report
</div>

  </div>
</div>


      </div>

      {/* Card 3 */}
  <div className="flex-1 rounded-[12.75px] border border-2 border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm">
  <div className="flex items-center gap-2">
    <h2 className="text-base font-semibold text-start text-[#0A0A0A]">Safety Insights</h2>
  </div>

  {/* First Card */}
  <div
    className="p-2 rounded-[3.5px] mt-8 space-y-1 text-start "
    style={{
      borderLeft: '4px solid #FB2C36',
      background: '#FEF2F2',
    }}
  >
    {/* Top row */}
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-2 pr-4 flex-1">
       {redhazard}
        <h2 className="text-sm font-medium text-[#0A0A0A]">
          Hazard Recognition Training Needed
        </h2>
      </div>
      <span className="text-sm font-medium text-[#0A0A0A] whitespace-nowrap">
        90% Risk Rating
      </span>
    </div>

    {/* Second row */}
    <div className="flex items-center gap-1 text-sm text-[#FB2C36] font-medium pl-6">
    {raisered}
      +5% from last month
    </div>
  </div>

  {/* Second Card */}
  <div
    className="p-2 rounded-[3.5px] mt-3 space-y-1 text-start "
    style={{
      borderLeft: '4px solid #FD9A00',
      background: '#FFFBEB',
    }}
  >
    {/* Top row */}
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-2 pr-4 flex-1">
        <h2 className="text-sm font-medium text-[#0A0A0A]">
          Hand Protection Compliance
        </h2>
      </div>
      <span className="text-sm font-medium text-[#0A0A0A] whitespace-nowrap">
        89% Compliance
      </span>
    </div>

    {/* Second row */}
    <div className="flex items-center gap-2 text-sm text-[#00A63E] font-medium pl-6">
 {greenstraight}
      -3% from last quarter
    </div>
  </div>
   <div
    className="p-2 rounded-[3.5px] mt-3 space-y-1 text-start "
    style={{
      borderLeft: '4px solid #00C950',
      background: '#FEF2F2',
    }}
  >
    {/* Top row */}
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-2 pr-4 flex-1">
        <h2 className="text-sm font-medium text-[#0A0A0A]">
    Days Without Lost Time Incident
        </h2>
      </div>
      <span className="text-sm font-medium text-[#0A0A0A] whitespace-nowrap">
  328 Days
      </span>
    </div>

    {/* Second row */}
    <div className="flex items-center gap-2 text-sm text-[#00A63E] font-medium pl-6">
{greendown}
    +26 days from last report
    </div>
  </div>
</div>

    </div>
  );
};

export default KeyInsights;
